import { Component, ViewEncapsulation } from '@angular/core';
import { QbuiltNavbarComponent } from '../shared/qbuilt-navbar/qbuilt-navbar.component';
import { QBuiltInspectorConstants } from '../models/constants/qbuilt-inspector.constants';
import { DropdownComponent } from "../shared/dropdown/dropdown.component";
import { SerialSearchComponent } from '../shared/serial-search/serial-search.component';
import { LargeButtonComponent } from '../shared/buttons/large-button.component';
import { Router } from '@angular/router';
import {  SerialTabModel } from '../shared/models/serial-tab.models';
import { CoreDataService } from 'src/app/modules/qbuilt/services/core-data.service';
import { CoreOrder, Line } from 'src/app/shared/models/core-order.model';
import { localStorageConstants, ProfileService, SpinnerService } from 'src/app/shared/services';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { QBuiltService } from 'src/app/modules/qbuilt/services/qbuilt-service';
import { QBuiltInspectorService } from '../services/qbuilit-inspector.service';
import { InspectionInitiationModel } from '../models/qbuilt-inspector.models';
import { SerialListModel } from '../shared/models/serial-tab.models';
import { FacilityConfigService } from 'src/app/modules/facility-config/services/facility-config.service';
import { FacilityDataModel } from 'src/app/modules/facility-config/models/facility-config.model';

@Component({
    selector: 'qbuilt-landing-page',
    imports: [
        QbuiltNavbarComponent,
        DropdownComponent,
        SerialSearchComponent,
        LargeButtonComponent,
        MatProgressSpinnerModule
    ],
    templateUrl: './qbuilt-landing-page.component.html',
    styleUrl: './qbuilt-landing-page.component.scss',
    encapsulation: ViewEncapsulation.Emulated
})

export class QbuiltLandingPageComponent {
  techNameTitle: string = this.qBuiltInspectorConstants.technicianNameTitle;
  facilityTitle: string = this.qBuiltInspectorConstants.facilityTitle;
  zoneTitle: string = this.qBuiltInspectorConstants.zoneTitle;
  logoutText: string = this.qBuiltInspectorConstants.logoutText;
  activeInspectionsTitle: string = this.qBuiltInspectorConstants.activeInspectionsTitle;
  btnText: string = this.qBuiltInspectorConstants.setupBtnText;
  startBtnText: string = this.qBuiltInspectorConstants.startBtnText;
  searchTitle: string = this.qBuiltInspectorConstants.serialSearchPlaceholder;

  btnDisabled: boolean = true; //sets start button disabled initially
  inspectionSetup: boolean; // Toggles if inspection setup is shown or not
  zone1Selected: boolean = false; // show or hide inspection setupBtn depending on zone selection
  zoneName: string = ''; // This will hold the selected zone value
  activeInspections: boolean = false; // This will determine if there are any active inspections
  selectedZoneId: string = '';

  serialNumber: string = '';

  facilityNumber: string;
  fullName: string;

  userZoneList: any[] = [];
  tabList: SerialTabModel[] = [];
  serialSectionList: SerialListModel[] = [];

  isLoading: boolean = true;

  showSetupBtn: boolean = false;

  userEmail: string = '';
  homeSections: any[] = [];

  sectionCount : string[] = [];

  departments: any[] = [];
  locations: any[] = [];

  activeInspectionData: any[] = [];
  tabLoading: boolean = false;

  facilityStationList: any[] = [];

  //sessionStorage Item
  landingPageSessionItems = {
    activeInspections: false,
    inspectionSetup: false,
    facilityStationList: [] as Array<{ Id: string; Name: string }>
  }

  cqmsSessionItems = {
    zoneId: '',
    zoneName: '',
    serialSectionList: [] as SerialListModel[],
    sectionList: [] as any[],
    capturedChanges: false,
    activeInspectionData: [] as any[],
    activeSerial: '',
    activeTabIndex: 0,
    selectedSerial: '',
    currentTabList: [] as any[],
    stationIdList: [] as string[],
    currentStationId: '',
    customTaskGroups: [] as any[],
    completeSectionList: [] as any[],
  }

  //session storage keys
  defectItemsKey: string = this.qBuiltInspectorConstants.defectItemsKey;
  cqmsSessionKey: string = this.qBuiltInspectorConstants.cqmsItemsKey;
  landingPageKey: string = this.qBuiltInspectorConstants.landingPageItemsKey;

  constructor(
    public qBuiltInspectorConstants: QBuiltInspectorConstants,
    private router: Router,
    private coreDataService: CoreDataService,
    private profileService: ProfileService,
    private qbuiltService: QBuiltService,
    private qbuiltInspectorService: QBuiltInspectorService,
    private facilityConfigService: FacilityConfigService
  ) {}

  ngOnInit() {
    this.isLoading = true;
    //captured changes to be used for save changes modal on home button
    this.cqmsSessionItems = { ...this.cqmsSessionItems, capturedChanges: false };
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
    this.qbuiltInspectorService.clearInspectionInitiationResponse();
    this.getDropDownData();
    //get UserEmail and facilityNumber to setup data
    this.profileService.getProfile().subscribe((profile) => {
      this.userEmail = profile.mail.toLocaleLowerCase();

      let temp = JSON.parse(localStorage.getItem(localStorageConstants.USER_FACILITIES_KEY));
      this.facilityNumber = temp.map((i: { Facility: { KeyChain: { LegacyId: any; }; }; }) => i.Facility.KeyChain.LegacyId)[0];
      sessionStorage.setItem('facilityNumber', this.facilityNumber);
      localStorage.setItem('facilityNumber', this.facilityNumber);

      //sets up user data and captures zones
      this.setupUserData();
      //used to get AOC tasks for 'observed defect list' on active inspection page
      this.getAllTasksByKind();
      this.getStationData();
    });

    const landingPageItems = JSON.parse(sessionStorage.getItem(this.landingPageKey) || '{}');
    this.inspectionSetup = landingPageItems.inspectionSetup || false;
   
    //set zone selection and selected zone to empty
    this.cqmsSessionItems = { ...this.cqmsSessionItems, zoneId: '', zoneName: '' };
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
    this.landingPageSessionItems = { ...this.landingPageSessionItems, activeInspections: false };
    sessionStorage.setItem(this.landingPageKey, JSON.stringify(this.landingPageSessionItems));

    if(this.zoneName === '') {
      this.inspectionSetup = false;
      this.showSetupBtn = false;
      this.landingPageSessionItems = { ...this.landingPageSessionItems, inspectionSetup: false };
      sessionStorage.setItem(this.landingPageKey, JSON.stringify(this.landingPageSessionItems));
    } else {
      this.showSetupBtn = true;
    }
    //clean out previous inspection data that should be reloaded 
    sessionStorage.removeItem(this.cqmsSessionKey);
    sessionStorage.removeItem(this.defectItemsKey);
  }

getSerialNumbers(facilityNumber: string) {
  this.coreDataService.getCoreOrdersByPlantNumber(facilityNumber);
  this.coreDataService.coreOrders$.subscribe((orders) => {
    this.serialSectionList = this.extractSerialNumbers(orders);    
    if (this.serialSectionList.length > 0) {
      this.cqmsSessionItems = { ...this.cqmsSessionItems, serialSectionList: this.serialSectionList };
      sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
    }
    
    this.isLoading = false;
    });
  }

  setupUserData() {
    //get email from local storage and pass it to service to get user info
    this.qbuiltInspectorService.getUserData(this.userEmail);
    this.qbuiltInspectorService.userData$.subscribe((data) => {
      if(data) {
        this.fullName = data.FirstName + ' ' + data.LastName;
        this.userZoneList = data.Zones;
        localStorage.setItem('userData', JSON.stringify(data));
      }
    });

    this.getSerialNumbers(this.facilityNumber);
  }


  getAllTasksByKind() {
    this.qbuiltService.GetAllTasksByKinds();
    this.qbuiltService.tasksByKindData$.subscribe((data) => {
      localStorage.removeItem('configuredTasks');
      this.qbuiltService.setAllTasks(data.Items);
      localStorage.setItem('configuredTasks', JSON.stringify(data.Items));
    });
  }

  //TODO - replace later with better cleaner backend call
  //gathers all station data for facility to use for assignments later in code
  getStationData() {
    this.facilityConfigService.getConfigurationData(this.facilityNumber);
    this.facilityConfigService.facilityData$.subscribe((data: FacilityDataModel[]) => {
      if(data) {
        this.facilityStationList = []; // Clear before populating
        data.forEach(zone => {
          if(zone.Stations) {
            this.facilityStationList.push(...zone.Stations.map(station => ({ Id: station.Id, Name: station.Name })));
          } 
        });
      }
    
      this.landingPageSessionItems = { ...this.landingPageSessionItems, facilityStationList: this.facilityStationList };
      sessionStorage.setItem(this.landingPageKey, JSON.stringify(this.landingPageSessionItems));
    });

  }

  onZoneSelected(selectedZone: any) {
    this.tabLoading = true;
    this.zoneName = selectedZone;
    let zoneId = this.userZoneList.find(zone => zone.Name === selectedZone)?.Id || '';
    this.activeInspectionCheck(zoneId.toString());
    this.cqmsSessionItems = { ...this.cqmsSessionItems, zoneId: zoneId, zoneName: this.zoneName };
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
    this.serialSectionList = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').serialSectionList || [];
    this.cqmsSessionItems = { ...this.cqmsSessionItems, selectedSerial: '' };
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
    this.showSetupBtn = true;
    this.inspectionSetup = false;
    this.landingPageSessionItems = { ...this.landingPageSessionItems, inspectionSetup: false };
    sessionStorage.setItem(this.landingPageKey, JSON.stringify(this.landingPageSessionItems));
  }

  inspectionSetupTrigger() {
    this.inspectionSetup = true;
    this.landingPageSessionItems = { ...this.landingPageSessionItems, inspectionSetup: true };
    sessionStorage.setItem(this.landingPageKey, JSON.stringify(this.landingPageSessionItems));
  }

  //recieves response from search component and determines if serial is valid or not before enabling the start button
  onSerialCheck(response: any) {
    if(response) {
      this.btnDisabled = false;
      this.serialNumber = response.serialNumber;
      this.getSectionCount(response.sectionCount);
      this.cqmsSessionItems = { ...this.cqmsSessionItems, selectedSerial: response };
      sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
      localStorage.setItem('activeSerial', response.serialNumber);
    } else {
      this.btnDisabled = true;
    }
  }

  //Converts home sections from # into list string A,B,C etc
  getSectionCount(sectionCount: number) {
    let sectList = Array.from({ length: sectionCount }, (_, i) => i + 1);
    sectList.forEach((section) => {
      if(this.homeSections.includes(String.fromCharCode(64 + section)) === false) {
        this.homeSections.push(String.fromCharCode(64 + section));
      }
    });
  }


  //logic to start new inspection after serial# search
  startInspection(serialNumber: string) {
    this.isLoading = true;
    let finalObj = this.setupActiveInspection(serialNumber);

    this.qbuiltInspectorService.saveInspectionInitiation(finalObj);
    localStorage.setItem('activeSerial', serialNumber);
    if(this.activeInspections === false) {
      this.router.navigate([`/cqms-home/inspections/${this.zoneName}`]);
      this.isLoading = false;
    } else {
      this.goToActiveInspections(this.zoneName);
    }
  }

  /** writes data to db for new inspection */
  setupActiveInspection(serialNumber: string) {
    let zoneId = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').zoneId || '';

    //logic to save to db here
    let inspInitiationObj: InspectionInitiationModel = {
      SerialNumber: serialNumber,
      PlantNumber: this.facilityNumber,
      HomeSections: this.homeSections,
      ZoneId: parseInt(zoneId)
    };

    return inspInitiationObj;
  }

  //Logic to navigate to active inspection screen based on zone selection
goToActiveInspections(zoneSelection: string) {
  this.cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : this.cqmsSessionItems;
  this.activeInspectionData = this.cqmsSessionItems.activeInspectionData || [];
  let tabList = this.setCurrentTabList(this.activeInspectionData);

  this.cqmsSessionItems = { ...this.cqmsSessionItems, currentTabList: tabList };
  sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));

  this.landingPageSessionItems = { ...this.landingPageSessionItems, activeInspections: true };
  sessionStorage.setItem(this.landingPageKey, JSON.stringify(this.landingPageSessionItems));

  if (tabList.length > 0) {
    this.cqmsSessionItems = { ...this.cqmsSessionItems, 
      activeSerial: tabList[0].serialNumber, 
      activeTabIndex: tabList[0].tabIndex, 
      sectionList: tabList[0].sectionList 
    };
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
  }

  this.cqmsSessionItems = { ...this.cqmsSessionItems, selectedSerial: '' };
  sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
  this.router.navigate([`/cqms-home/inspections/${zoneSelection}`]);
  this.isLoading = false;
}

setCurrentTabList(activeInspectionData: any[]) 
{
    const tabList: SerialTabModel[] = activeInspectionData.map((inspection: any, index: number) => {
    const statusId = inspection.statusId;
    const serialNumber = inspection.serialNumber;
    const sectionList = inspection.sectionList || [];
    const sectionCount = sectionList.length;

    return {
      serialNumber,
      tabIndex: index,
      sectionCount,
      zoneSelection: inspection.zoneSelection,
      sectionList,
      statusId
    };
  });
  
  return tabList;
}

  getDropDownData() {
    this.qbuiltInspectorService.departments$.subscribe((data) => {
      if(data) {
        this.departments = data.map((dept: any) => ({ Id: dept.Id, Name: dept.Name }));
        localStorage.setItem('departments', JSON.stringify(this.departments));
      }
    });

    this.qbuiltInspectorService.locations$.subscribe((data) => {
      if(data) {
        this.locations = data.map((loc: any) => ({ Id: loc.Id, Name: loc.Name }));
        localStorage.setItem('locations', JSON.stringify(this.locations));
      }
    });

    this.qbuiltInspectorService.getInspectionDepartments();
    this.qbuiltInspectorService.GetInspectionLocations();
  }

  //determine if there are any active inspections for the selected zone
  activeInspectionCheck(zoneName: string) {
    this.cqmsSessionItems = { ...this.cqmsSessionItems, activeInspectionData: [] };
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
    this.qbuiltInspectorService.getInspectionProgressData(`${this.facilityNumber}-${zoneName}`);
    this.qbuiltInspectorService.inspectionProgressData$
      .subscribe((data: any) => {
        if (!data) {
          this.activeInspections = false;
          this.landingPageSessionItems = { ...this.landingPageSessionItems, activeInspections: false };
          sessionStorage.setItem(this.landingPageKey, JSON.stringify(this.landingPageSessionItems));
          this.cqmsSessionItems = { ...this.cqmsSessionItems, activeInspectionData: [] };
          sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
          this.tabLoading = false;
          return;
        }

        var inspectionProgress = JSON.parse(data.InspectionData || '[]');
        var inspectionData = inspectionProgress;

        if (inspectionData.length > 0) {
          this.activeInspections = true;
          this.landingPageSessionItems = { ...this.landingPageSessionItems, activeInspections: true };
          sessionStorage.setItem(this.landingPageKey, JSON.stringify(this.landingPageSessionItems));
          this.cqmsSessionItems = { ...this.cqmsSessionItems, activeInspectionData: inspectionData };
          sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
        } else {
          this.activeInspections = false;
          this.landingPageSessionItems = { ...this.landingPageSessionItems, activeInspections: false };
          sessionStorage.setItem(this.landingPageKey, JSON.stringify(this.landingPageSessionItems));
        }

        this.tabLoading = false;
      });

  }

  //Will need to implement logout functionality and make sure user cannot access ClaytonNext
  userLogout() {
    //logic to log user out here
    // sessionStorage.clear();
    // localStorage.clear();
    // window.location.reload();
  }

private extractSerialNumbers(orders: CoreOrder[]): SerialListModel[] {
  return orders
    .flatMap(order => order.lines)
    .map(line => this.createSerialNumberItemList(line))
    .filter(item => item.serialNumber !== '');
}

private createSerialNumberItemList(line: Line): SerialListModel {
  const longSerialIdentifier = line.product?.home?.identifiers?.find(
    identifier => identifier.key === 'LongSerialNumber'
  );
  
  return {
    serialNumber: longSerialIdentifier?.value || line.product?.home?.id || '',
    sectionCount: line.product?.home?.sectionCount || 0,
    inUse: false
  } as SerialListModel;
  }
}